<template>
    <div class="dialog">
        <!-- 注册 -->
        <el-dialog :visible.sync="registerDialog" width="50%" center :close-on-click-modal="false">
            <span slot="title" class="register-title">会员注册</span>
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
            >
                <el-form-item prop="username">
                    <el-input v-model="ruleForm.username" placeholder="请填写账号"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                        placeholder="请输入8-16位密码，包含大写、小写字母及数字"
                        v-model="ruleForm.password"
                        type="password"
                        show-password
                    ></el-input>
                </el-form-item>
                <el-form-item prop="checkPass">
                    <el-input
                        placeholder="请确认密码"
                        v-model="ruleForm.checkPass"
                        type="password"
                        show-password
                    ></el-input>
                </el-form-item>
                <el-form-item prop="phone">
                    <el-input
                        placeholder="请输入手机号"
                        v-model="ruleForm.phone"
                        class="input-with-select"
                        type="number"
                        pattern="[0-9]*"
                        onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                    >
                        <el-select v-model="select" slot="prepend" disabled>
                            <el-option label="+86" value="1"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item prop="code">
                    <el-input
                        placeholder="请输入验证码"
                        v-model="ruleForm.code"
                        type="number"
                        pattern="[0-9]*"
                    >
                        <el-button
                            slot="append"
                            @click="getMessageCode('register')"
                            :disabled="codeGet"
                        >{{ codeText }}</el-button>
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="register" class="login-button" round>注册</el-button>

                <el-divider>已有账号？</el-divider>
                <el-button
                    round
                    @click="registerDialog = false,loginDialog = true"
                    class="login-button"
                >登录</el-button>
            </span>
        </el-dialog>
        <!-- 登录 -->
        <el-dialog :visible.sync="loginDialog" width="40% " center :close-on-click-modal="false">
            <span slot="title" class="register-title">登录</span>
            <el-form :model="loginForm" :rules="passRules">
                <el-form-item prop="username">
                    <el-input
                        placeholder="账号名称"
                        suffix-icon="el-icon-user"
                        v-model="loginForm.username"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                        placeholder="密码"
                        type="password"
                        v-model="loginForm.password"
                        :show-password="true"
                    ></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="login-footer">
                <div class="remeber-forget">
                    <el-checkbox v-model="checked">下次自动登录</el-checkbox>
                    <div
                        type="text"
                        @click="forgetDialog = true,loginDialog = false"
                        class="forget"
                    >忘记密码</div>
                </div>
                <el-button type="primary" @click="login" class="login-button" round>登录</el-button>
                <el-divider>没有账号？</el-divider>
                <el-button
                    round
                    @click="loginDialog = false,registerDialog = true"
                    class="login-button"
                >创建新的账户</el-button>
            </span>
        </el-dialog>
        <!-- 忘记密码 -验证码-->
        <el-dialog :visible.sync="forgetDialog" width="40%" center :close-on-click-modal="false">
            <span slot="title" class="register-title">忘记密码？</span>
            <el-form
                :model="forgetForm"
                :rules="forgetRules"
                ref="ruleForm"
                label-width="100px"
                class="forget-form"
                label-position="top"
            >
                <el-form-item prop="phone">
                    <el-input
                        placeholder="手机号"
                        v-model="forgetForm.phone"
                        class="input-with-select"
                        type="number"
                        pattern="[0-9]*"
                        onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                    >
                        <el-select v-model="select" slot="prepend" disabled>
                            <el-option label="+86" value="1"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item prop="code">
                    <el-input
                        placeholder="验证码"
                        v-model="forgetForm.code"
                        type="number"
                        pattern="[0-9]*"
                    >
                        <el-button
                            slot="append"
                            @click="getMessageCode('forget')"
                            :disabled="forgetCodeGet"
                        >{{ forgetCodeText }}</el-button>
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="forgetNext" class="login-button" round>下一步</el-button>
                <div class="forget-bot" @click="forgetDialog=false, loginDialog = true">返回登录</div>
            </span>
        </el-dialog>
        <!-- 忘记密码 -重置密码-->
        <el-dialog :visible.sync="forgetDialog2" width="40%" center :close-on-click-modal="false">
            <span slot="title" class="register-title">修改密码</span>
            <el-form
                :model="forgetForm"
                :rules="forgetRules"
                ref="ruleForm"
                label-width="100px"
                class="forget-form"
                label-position="top"
            >
                <el-form-item prop="newpassword">
                    <el-input
                        placeholder="请输入8-16位新密码，包含字母及数字"
                        v-model="forgetForm.newpassword"
                        type="password"
                        show-password
                    ></el-input>
                </el-form-item>
                <el-form-item prop="checkPass">
                    <el-input
                        placeholder="请确认密码"
                        v-model="forgetForm.checkPass"
                        type="password"
                        show-password
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="forget" class="login-button" round>下一步</el-button>
            </span>
        </el-dialog>
        <!-- 忘记密码 -重置成功-->
        <el-dialog :visible.sync="forgetDialog3" width="40%" center :close-on-click-modal="false">
            <span slot="title" class="register-title">找回密码</span>
            <div class="forget-login">
                <i class="el-icon-success"></i>
                <p>您已经成功设置密码，请使用新密码登录</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    class="login-button"
                    round
                    @click="forgetDialog3 = false,loginDialog=true"
                >确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    // 必须引用
    import { CHINA_MOBILE } from '../../request/regular';
    import { mapActions, mapGetters } from 'vuex';
    import moment from 'moment';
    export default {
        components: {},
        data() {
            var validatePass = (rule, value, callback) => {
                console.log('validatePass', value);
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    let regu = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,16}$/;
                    if (!regu.test(value)) {
                        callback(new Error('密码需为8-16位字母加数字组合'));
                    }
                    if (this.ruleForm.checkPass !== '') {
                        this.$refs.ruleForm.validateField('checkPass');
                    }
                    callback();
                }
            };
            var validateName = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请填写账号名称'));
                } else {
                    let regu = /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/;
                    if (!regu.test(value)) {
                        callback(new Error('不能包含特殊字符'));
                    }
                    callback();
                }
            };

            var validatePass2 = (rule, value, callback) => {
                let password = this.ruleForm.password;
                if (this.forgetDialog2) {
                    password = this.forgetForm.newpassword;
                }
                console.log(
                    'validatePass222',
                    value,
                    password,
                    this.forgetForm.newpassword
                );
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value != password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号不能为空'));
                }
                setTimeout(() => {
                    if (!CHINA_MOBILE.test(value)) {
                        callback(new Error('请输入正确的手机号'));
                    } else {
                        callback();
                    }
                }, 1000);
            };
            return {
                checked: false, // 是否自动登录
                registerDialog: false,
                loginDialog: false,
                forgetDialog: false,
                forgetDialog2: false,
                forgetDialog3: false,
                select: '+86',
                codeGet: false,
                codeText: '获取验证码',
                loginCodeGet: false,
                loginCodeText: '获取验证码',
                forgetCodeGet: false,
                forgetCodeText: '获取验证码',
                activeName: 'first',
                ruleForm: {
                    username: '',
                    password: '',
                    phone: '',
                    code: '',
                    checkPass: ''
                },
                rules: {
                    username: [{ validator: validateName, trigger: 'blur' }],
                    password: [{ validator: validatePass, trigger: 'blur' }],
                    checkPass: [{ validator: validatePass2, trigger: 'blur' }],
                    phone: [{ validator: checkPhone, trigger: 'blur' }],
                    code: [
                        { required: true, message: '请填写验证码', trigger: 'blur' }
                    ]
                },
                loginForm: {
                    username: '',
                    password: ''
                },
                passRules: {
                    username: [
                        {
                            required: true,
                            message: '请填写账号名称',
                            trigger: 'blur'
                        }
                    ],
                    password: [
                        { required: true, message: '请填写密码', trigger: 'blur' }
                    ]
                },
                loginMessageForm: {
                    phone: '',
                    code: ''
                },
                messageRules: {
                    phone: [{ validator: checkPhone, trigger: 'blur' }],
                    code: [
                        { required: true, message: '请填写验证码', trigger: 'blur' }
                    ]
                },
                forgetForm: {
                    phone: '',
                    code: '',
                    newpassword: '',
                    checkPass: ''
                },
                forgetRules: {
                    phone: [{ validator: checkPhone, trigger: 'blur' }],
                    code: [
                        { required: true, message: '请填写验证码', trigger: 'blur' }
                    ],
                    newpassword: [{ validator: validatePass, trigger: 'blur' }],
                    checkPass: [{ validator: validatePass2, trigger: 'blur' }]
                }
            };
        },
        computed: {
            ...mapGetters(['userInfo'])
        },
        created() {
            this.getLoginStatus();
        },
        methods: {
            ...mapActions(['getLoginStatus']),
            gotopersonalcenter() {
                this.$router.push({
                    name: 'personal-center'
                });
            },
            toRegister() {
                this.registerDialog = true;
            },
            toLog() {
                this.loginDialog = true;
            },
            getMessageCode(opt) {
                let type = this.registerDialog ? 2 : 1;
                let phone = this.ruleForm.phone;
                if (opt === 'login') {
                    phone = this.loginMessageForm.phone;
                }
                if (opt === 'forget') {
                    phone = this.forgetForm.phone;
                    type = 5;
                }
                if (!CHINA_MOBILE.test(phone)) {
                    this.$message({
                        message: '请输入正确的手机号',
                        type: 'warning'
                    });
                    return;
                }
                this.httpPost(this.$root.getMessageCode, {
                    phone: phone,
                    type: type
                })
                    .then(result => {
                        this.setTime(opt);
                    })
                    .catch(err => {
                        console.error('getMessageCode-err', err);
                    });
            },
            register() {
                let ruleValue = Object.values(this.ruleForm);
                if (ruleValue.indexOf('') > -1) {
                    this.$message({
                        message: '请完整填写注册信息',
                        type: 'warning'
                    });
                    return;
                }
                this.httpPost(this.$root.setUserRegister, {
                    ...this.ruleForm
                })
                    .then(result => {
                        this.$store.commit('setToken', result.token);
                        this.loginTimeDown(result.expires);
                        this.$message({
                            message: '注册成功',
                            type: 'success'
                        });
                        // this.getLoginStatus();
                        this.registerDialog = false;
                        // location.reload();
                    })
                    .catch(err => {
                        console.error('setUserRegister-err', err);
                    });
            },
            setTime(opt) {
                //    倒计时
                let demo = 120;
                if (opt === 'register') {
                    this.codeText = demo + 'S后重新获取';
                    this.codeGet = true;
                }
                if (opt === 'login') {
                    this.loginCodeText = demo + 'S后重新获取';
                    this.loginCodeGet = true;
                }
                if (opt === 'forget') {
                    this.forgetCodeText = demo + 'S后重新获取';
                    this.forgetCodeGet = true;
                }
                let setTer = setInterval(() => {
                    if (demo > 0) {
                        if (opt === 'register') {
                            this.codeText = demo + 'S后重新获取';
                            // this.codeGet = true;
                        }
                        if (opt === 'login') {
                            this.loginCodeText = demo + 'S后重新获取';
                            this.loginCodeGet = true;
                        }
                        if (opt === 'forget') {
                            this.forgetCodeText = demo + 'S后重新获取';
                            // this.forgetCodeGet = true;
                        }
                        demo--;
                    } else {
                        clearInterval(setTer);
                        if (opt === 'register') {
                            this.codeText = '获取验证码';
                            this.codeGet = false;
                        }
                        if (opt === 'login') {
                            this.loginCodeText = '获取验证码';
                            this.loginCodeGet = false;
                        }
                        if (opt === 'forget') {
                            this.forgetCodeText = '获取验证码';
                            this.forgetCodeGet = false;
                        }
                        // this.codeText = '获取验证码';
                        // this.codeGet = true;
                        // this.code = '';
                    }
                }, 1000);
            },
            handleClick(active) {
                console.log('activeName----', active.name, this.activeName);
                if (active.name === 'second') {
                    this.loginForm.username = '';
                    this.loginForm.password = '';
                } else {
                    this.loginMessageForm.phone = '';
                    this.loginMessageForm.code = '';
                }
            },
            login() {
                let loginData = { ...this.loginForm };
                if (this.activeName === 'second') {
                    loginData = { ...this.loginMessageForm };
                }
                let loginValue = Object.values(loginData);
                if (loginValue.indexOf('') > -1) {
                    this.$message({
                        message: '请完整填写登录信息',
                        type: 'warning'
                    });
                    return;
                }
                this.httpPost(this.$root.setUserLogin, {
                    ...loginData
                })
                    .then(result => {
                        this.$store.commit('setToken', result.token);
                        if (this.checked) {
                            this.$store.commit('setLocalToken', result.token);
                        } else {
                            this.$store.commit('setLocalToken', '');
                        }
                        this.$message({
                            message: '登录成功',
                            type: 'success',
                            duration: 500
                        });
                        this.loginTimeDown(result.expires);
                        this.loginDialog = false;
                    })
                    .catch(err => {
                        console.error('setUserLogin-err', err);
                        this.$store.commit('setToken', '');
                    });
            },
            forgetNext() {
                if (this.forgetForm.phone == '' || this.forgetForm.code == '') {
                    this.$message({
                        message: '请完整填写信息',
                        type: 'warning'
                    });
                    return;
                }
                this.forgetDialog = false;
                this.forgetDialog2 = true;
            },
            forget() {
                let forgetValue = Object.values(this.forgetForm);
                if (forgetValue.indexOf('') > -1) {
                    this.$message({
                        message: '请完整填写信息',
                        type: 'warning'
                    });
                    return;
                }
                this.httpPost(this.$root.setUserNewPass, {
                    ...this.forgetForm
                })
                    .then(result => {
                        this.forgetDialog2 = false;
                        this.forgetDialog3 = true;
                        this.forgetForm.phone = '';
                        this.forgetForm.code = '';
                        this.forgetForm.newpassword = '';
                        this.forgetForm.checkPass = '';
                    })
                    .catch(err => {
                        console.error('setUserNewPass-err', err);
                    });
            },
            loginTimeDown(time) {
                let down = Number(time) - Math.round(moment() / 1000);
                console.log(
                    'downdoewm',
                    down * 1000,
                    time,
                    Math.round(moment() / 1000)
                );
                setTimeout(() => {
                    this.$message({
                        message: '登录过期，请重新登录！',
                        type: 'error'
                    });
                    this.$store.commit('setToken', '');
                    // this.getLoginStatus();
                }, down * 1000);
            },
            hasNotice() {
                setTimeout(() => {
                    if (this.userInfo.noticenum > 0) {
                        this.$confirm(
                            '您有新的系统通知未读? 是否前往查看',
                            '提示',
                            {
                                confirmButtonText: '查看',
                                cancelButtonText: '取消',
                                type: 'info'
                            }
                        )
                            .then(() => {
                                this.$router.replace(
                                    'personal-center?type=systemshow'
                                );
                            })
                            .catch(() => {});
                    }
                }, 600);
            }
        },
        watch: {
            '$store.state.login.token': function() {
                console.log('watch-log');
                this.getLoginStatus();
                this.hasNotice();
            },
            registerDialog(newValue, oldValue) {},
            loginDialog(newValue, oldValue) {},
            forgetDialog(newValue, oldValue) {},
            codeGet(newValue, oldValue) {},
            loginCodeGet(newValue, oldValue) {
                console.log('loginCodeGet', newValue, oldValue);
            },
            forgetCodeGet(newValue, oldValue) {}
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .dialog {
        >>>.el-dialog {
            min-width: 295px;
            max-width: 540px;
            max-height: 727px;
            border-radius: 16px;

            .el-dialog__header {
                flex-x();
                text-align: left;
                margin-left: 5%;
                font-size: 28px;
                font-weight: 500;
                color: rgba(0, 0, 0, 0.85);
            }

            .el-dialog__headerbtn {
                margin-right: 5%;

                i {
                    width: 24px;
                    height: 24px;
                    font-size: 24px;
                }
            }
        }

        >>>.el-form {
            width: 90% !important;
            margin-left: 5%;
        }

        >>>.el-form-item {
            margin-bottom: 5px !important;
        }

        >>>.el-input__inner {
            border-radius: 0;
            border: 1px solid white;
            border-bottom: 1px solid rgba(0, 0, 0, 0.16);
            padding: 0;
        }

        >>>.el-form-item__content {
            margin-left: 0 !important;
        }

        >>> .el-input-group__prepend {
            width: 30px;
            background: white;
            border-left: 0;
            border-top: 0;
        }

        >>>.el-input-group__append {
            width: 36px;
            color: rgba(0, 0, 0, 0.45);
            background: white;
            border-top: 0;
            border-right: 0;

            .el-button {
                background: #EEEEEE;
                height: 32px;
            }
        }

        .el-divider--horizontal {
            margin: 15px 0;
            margin-left: 5%;
            width: 90%;
        }

        .el-divider__text.is-center {
            color: rgba(0, 0, 0, 0.25);
            font-size: 14px;
        }

        .dialog-footer {
            // margin-left: 5%;
            width: 90%;
            // flex-x(space-between);
        }

        .register {
            margin-left: 14px;
            color: blue;
            line-height: 22px;
        }

        .register:hover {
            cursor: pointer;
            color: blue;
        }

        .register-button {
            width: 173px;
        }

        .remeber-forget {
            flex-x(space-between);
            width: 90%;
            margin-top: -35px;
            margin-left: 5%;
            height: 24px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.45);
            line-height: 24px;
        }

        .forget {
            // width: 90%;
            // margin-left: 5%;
            // color: rgba(0, 0, 0, 0.45);
            // line-height: 22px;
            text-align: right;
        }

        .forget:hover {
            cursor: pointer;
        }

        .forget-bot {
            flex-x(flex-start);
            color: #1A7DFF;
            margin-left: 5%;
            font-size: 14px;
            margin-top: 20px;
        }

        .forget-bot:hover {
            cursor: pointer;
        }

        .forget-login {
            flex-y(center);
            margin-left: 5%;
            margin-top: 20px;

            i {
                font-size: 48px;
                color: #52c41a;
            }

            p {
                font-size: 14px;
                margin-top: 20px;
            }
        }

        .login-button {
            margin: 10px 0;
            width: 90%;
        }

        >>>.el-dialog__footer {
            padding-bottom: 10%;
        }

        .forget-form {
            >>>.el-form {
                width: 50% !important;
                margin-left: 15%;
            }
        }
    }
</style>
